<template>
  <div class="container py-5 bg-transparent">
    <!-- Header -->
    <header class="text-center mb-4">
      <h1 class="text-primary display-5 display-md-4">Institute Teachers</h1>
      <p class="text-muted px-3">Explore the profiles of our esteemed educators and their specialties.</p>
    </header>

    <!-- Token and ID Info -->
    <!-- <div class="card bg-light mb-4 shadow-sm">
      <div class="card-body">
        <h5 class="card-title text-center text-secondary">Authentication Info</h5>
        <div class="row text-break">
          <div class="col-12 col-md-4 mb-3 mb-md-0">
            <p><strong>Token:</strong> {{ token }}</p>
          </div>
          <div class="col-12 col-md-4 mb-3 mb-md-0">
            <p><strong>ID:</strong> {{ id }}</p>
          </div>
          <div class="col-12 col-md-4">
            <p><strong>Institute ID:</strong> {{ instituteId }}</p>
          </div>
        </div>
      </div>
    </div> -->

    <!-- Teachers List -->
     <!-- Loading Spinner -->
<div v-if="loading" class="text-center my-5">
  <div class="spinner-border text-primary" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>
</div>

    <div class="row"  v-if="!loading">
      <div
        class="col-12 col-sm-6 col-lg-4 mb-4"
        v-for="teacher in teachers"
        :key="teacher.teacher_id"
      >
        <div class="cardsets h-100 border-0 shadow rounded">
          <div class="card-body d-flex flex-column">
            <h5 class="card-title text-primary">
              {{ teacher.first_name }} {{ teacher.last_name }}
            </h5>
            <p class="card-text text-secondary mb-2">
              <i class="bi bi-telephone"></i> <strong>Phone:</strong> {{ teacher.contact }}
            </p>
            <p class="card-text text-secondary">
              <i class="bi bi-building"></i> <strong>Institute:</strong> {{ teacher.institute_name }}
            </p>

            <!-- Subjects & Items -->
            <h6 class="text-muted mt-3">Subjects & Items</h6>
            <ul class="custom-list-group flex-grow-1">
              <li
                class="custom-list-item"
                v-for="item in teacher.items"
                :key="item.item_id"
              >
                <div class="d-flex align-items-center flex-wrap">
                  <i class="bi bi-box-seam text-primary me-2"></i>
                  <span class="item-name">{{ item.item_name }}</span>
                </div>
                <span class="badge bg-success subject-badge mt-2 mt-sm-0">
                  {{ item.subject_name }}
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import axios from "axios";

export default {
  data() {
    return {
      token: "",
      id: "",
      instituteId: "",
      teachers: [],
      loading: false,
    };
  },
  mounted() {
    this.token = localStorage.getItem("token");
    this.id = localStorage.getItem("id");
    this.instituteId = localStorage.getItem("institute_id");
    this.fetchTeachers();
  },
  methods: {
    // async fetchTeachers() {
    //   this.loading = true;
    //   try {
    //     const response = await axios.post("/get-teachers", {
    //       token: this.token,
    //       institute_id: this.instituteId,
    //     });

    //     if (response.data.success) {
    //       this.teachers = response.data.teachers;
    //     } else {
    //       console.error(response.data.message);
    //     }
    //   } catch (error) {
    //     console.error("Error fetching teachers:", error);
    //   } finally {
    //     this.loading = false;
    //   }
    // },

    async fetchTeachers() {
  this.loading = true;
  try {
    const response = await axios.post("/get-teachers", {
      token: this.token,
      institute_id: this.instituteId,
    });

    if (response.data.success) {
      this.teachers = response.data.teachers;
    } else {
      console.error(response.data.message);
    }
  } catch (error) {
    console.error("Error fetching teachers:", error);
  } finally {
    this.loading = false;
  }
},
  },
};
</script>

<style scoped>
.container{
  height: 100%;
}

.cardsets {
  background-color: white;
  padding: 5px;
  border-radius: 5px solid rgb(172, 172, 172);
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

.custom-list-group {
  list-style: none;
  padding: 0;
  margin: 0;
}

.custom-list-item {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: center;
  padding: 0.75rem 1rem;
  margin-bottom: 0.5rem;
  background-color: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  transition: background-color 0.3s ease, transform 0.2s ease;
}

.custom-list-item:hover {
  background-color: #e2e6ea;
  transform: translateY(-3px);
}

.item-name {
  font-weight: 500;
  color: #343a40;
}

.subject-badge {
  font-size: 0.85rem;
  font-weight: 600;
}
</style>
